// tratamiento de mensajes.js
import Utils from '@/plugins/utils'

const state = {
    client:null
};

const mutations = {
    setCliente(state,cliente){
        state.client=cliente
    }
};

const actions = {
    async tratarBitVida({rootState,dispatch},mensaje_tratado){
        //console.log('vida:',mensaje_tratado)
        state.life=mensaje_tratado;
        this.dispatch('setEstadoTrabajo',state.life.estado)
        this.dispatch('timer/detenerTemporizador')
        
        this.dispatch('setTiempoHornoEnMarcha',mensaje_tratado.tiempo_en_marcha_real)
        this.dispatch('setTiempoHornoEnPausa',mensaje_tratado.tiempo_en_pausa_real)

        this.dispatch('setTiempoRealZ1', mensaje_tratado.pv_zona1)
        this.dispatch('setTiempoRealZ2', mensaje_tratado.pv_zona2)
        this.dispatch('setTiempoRealZAgua', mensaje_tratado.pv_zonaAgua)

        if (mensaje_tratado.id_trabajo && Object.keys(rootState.trabajoCargado).length == 0) {  
            const id_trabajo = mensaje_tratado.id_trabajo
            const datos_trabajo_raw = await this.dispatch('api/getTrabajo', id_trabajo)
            const datos_trabajo = datos_trabajo_raw.data;
            this.dispatch('setTrabajo',datos_trabajo)
            rootState.detalles_tratamiento_actual=datos_trabajo.detalles;
        }
        if (mensaje_tratado.id_trabajo && mensaje_tratado.modificado) {  // si se ha modificado el trabajo online
            const id_trabajo = mensaje_tratado.id_trabajo
            const datos_trabajo_raw = await this.dispatch('api/getTrabajo', id_trabajo)
            const datos_trabajo = datos_trabajo_raw.data;
            this.dispatch('setTrabajo',datos_trabajo)
            rootState.detalles_tratamiento_actual=datos_trabajo.detalles;
        }
        if(!rootState.inicio_ciclo && mensaje_tratado.date_inicio && mensaje_tratado.estado != 1 && mensaje_tratado.estado != 6){
            let fecha = new Date(mensaje_tratado.date_inicio)
            this.dispatch('setInicioCiclo',fecha)
        }
        if(mensaje_tratado.inicio_programado && mensaje_tratado.inicio_programado != null){
            rootState.inicio_programado = new Date(mensaje_tratado.inicio_programado)
        }

        if(mensaje_tratado.estado == 1 && mensaje_tratado.id_trabajo == null){
            this.dispatch('setInicioCiclo',null)
            this.dispatch('setTrabajo',{})
            this.dispatch('setTiempoHornoEnMarcha',0)
            // this.dispatch('acSetTiempoMarcha',0)
            this.dispatch('setPVZona1',[])
            this.dispatch('setPVZona2',[])
            this.dispatch('setPVZonaAgua',[])
            this.dispatch('setSetpoints',[])
        }
    },
    padZero(_,number) {
        return number < 10 ? `0${number}` : number;
    },
    async getDatosTrabajo({rootState,dispatch},mensaje){
        if(mensaje.inicio_programado && mensaje.inicio_programado != null){
            rootState.inicio_programado = new Date(mensaje.inicio_programado)
        }
        if(mensaje.datos_plc){
            this.dispatch('setDatosPopup',mensaje.datos_plc)
        }
        if(mensaje.alarmas_activas){
            this.dispatch('setAlarmasActivas',mensaje.alarmas_activas)
        }
        if (mensaje.id_trabajo != null) {
            if(mensaje.date_inicio && mensaje.estado != 1 && mensaje.estado != 6){
                let fecha = new Date(mensaje.date_inicio)
                this.dispatch('setInicioCiclo',fecha)
            }
            const id_trabajo = mensaje.id_trabajo
            const datos_trabajo_raw = await this.dispatch('api/getTrabajo', id_trabajo)
            const datos_trabajo = datos_trabajo_raw.data;
            this.dispatch('setTrabajo',datos_trabajo)
            let tratamiento = mensaje.detalles;
            console.log('AQUII');
            console.log(mensaje);
            
            if (Object.keys(tratamiento).length > 0) {
               console.log('TRATAMIENTO: ',tratamiento)

                if (tratamiento.momento_lectura) {
                
                    const dispatchPromises = [];
                    tratamiento.momento_lectura.forEach((momento,index) => {
                        // console.log("momento",momento)
                        // console.log("index",index)
                        const fecha =  new Date(momento);
                        const dia = fecha.getDate()
                        const current_element_z1 = tratamiento.zona_1[index]
                        const current_element_z2 = tratamiento.zona_2[index]
                        const current_element_agua = tratamiento.zona_agua[index]
                        const current_element_setpoint = tratamiento.setpoint[index]
                        const current__aereo = tratamiento.aereo[index]
                        const current__contacto = tratamiento.contacto[index]
                        const hours = fecha.getHours() < 10 ? `0${fecha.getHours()}` :fecha.getHours()
                        const minutes = fecha.getMinutes() < 10 ? `0${fecha.getMinutes()}` :fecha.getMinutes()
                        const seconds = fecha.getSeconds() < 10 ? `0${fecha.getSeconds()}` :fecha.getSeconds()
                        let valor_zona_1 = null
                        if(current__aereo !== null) valor_zona_1 = (current__aereo.z1)?current__aereo.z1:null;
                        let valor_zona_2 = null
                        if(current__aereo !== null) valor_zona_2 = (current__aereo.z2)?current__aereo.z2:null;
                        let valor_zona_agua = null
                        if(current_element_agua !== null) valor_zona_agua = (current_element_agua.pv)?current_element_agua.pv:null;
                        let valor_setpoint = null
                        if(current_element_setpoint !== null) valor_setpoint = (current_element_setpoint.valor)?current_element_setpoint.valor:null;
                        let valor_contacto_1 = null
                        if(current__contacto !== null) valor_contacto_1 = (current__contacto.z1)?current__contacto.z1:null;
                        let valor_contacto_2 = null
                        if(current__contacto !== null) valor_contacto_2 = (current__contacto.z2)?current__contacto.z2:null;
                        const dispatchPromisesPerElement = [
                            this.dispatch('pushDatosP1',{y: valor_zona_1, x:`${dia} - ${hours}:${minutes}`}),
                            this.dispatch('pushDatosP2',{y: valor_zona_2, x:`${dia} - ${hours}:${minutes}`}),
                            this.dispatch('pushDatosAgua',{y: valor_zona_agua, x:`${dia} - ${hours}:${minutes}`}),
                            this.dispatch('pushDatosSetpoint',{y: valor_setpoint, x:`${dia} - ${hours}:${minutes}`}),
                            this.dispatch('pushDatosP1Contacto',{y: valor_contacto_1, x:`${dia} - ${hours}:${minutes}`}),   
                            this.dispatch('pushDatosP2Contacto',{y: valor_contacto_2, x:`${dia} - ${hours}:${minutes}`}),
                        ];
                        dispatchPromises.push(...dispatchPromisesPerElement);
                
                        // console.log(current_element_setpoint)
                    });
                    await Promise.all(dispatchPromises);

                }
            }
            rootState.detalles_tratamiento_actual=datos_trabajo.detalles;

        }
    },
    padZero(_,number) {
        return number < 10 ? `0${number}` : number;
    },
    getHoraFinTratamiento({rootState},tratamiento){
        const hora_inicio_raw = tratamiento.date_inicio;
        const tiempo_en_pausa_raw = tratamiento.tiempo_en_pausa_real;
        const tiempo_en_marcha_raw = tratamiento.tiempo_en_marcha_real;
        const detalles_raw = rootState.detalles_tratamiento_actual

        //console.log({hora_inicio_raw,tiempo_en_marcha_raw,tiempo_en_pausa_raw,detalles_raw})
    },
    async tratar_datos_tratamiento({dispatch, rootState},tratamiento){
           
        if (Object.keys(tratamiento).length > 0) {
            if(!rootState.inicio_ciclo && tratamiento.date_inicio){
                let fecha = new Date(tratamiento.date_inicio)
                this.dispatch('setInicioCiclo',fecha)
            }
            let fecha = new Date(tratamiento.momento_lectura);
            const hours = await dispatch('padZero',fecha.getHours());
            const minutes = await dispatch('padZero',fecha.getMinutes());
            const seconds = await dispatch('padZero',fecha.getSeconds());
         
            let dia = fecha.getDate()
            let nuevos=[false,false,false,false]
            console.log('ENTROOOO');
            console.log(tratamiento);
            
            const valor_zona_1 = (tratamiento.zona_1)?tratamiento.zona_1.pv:null;
            this.dispatch('pushDatosP1',{y: valor_zona_1, x:`${dia} - ${hours}:${minutes}`})

            const valor_zona_2 = (tratamiento.zona_2)?tratamiento.zona_2.pv:null;
            this.dispatch('pushDatosP2',{y: valor_zona_2, x:`${dia} - ${hours}:${minutes}`})

            const valor_zona_agua = (tratamiento.zona_agua)?tratamiento.zona_agua.pv:null;
            this.dispatch('pushDatosAgua',{y: valor_zona_agua, x:`${dia} - ${hours}:${minutes}`})

            const valor_setpoint = (tratamiento.setpoint)?tratamiento.setpoint:null;
            this.dispatch('pushDatosSetpoint',{y: valor_setpoint, x:`${dia} - ${hours}:${minutes}`})

            const valor_contacto_1 = (tratamiento.contacto)?tratamiento.contacto.z1:null;
            this.dispatch('pushDatosP1Contacto',{y: valor_contacto_1, x:`${dia} - ${hours}:${minutes}`})
            
            const valor_contacto_2 = (tratamiento.contacto)?tratamiento.contacto.z2:null;
            this.dispatch('pushDatosP2Contacto',{y: valor_contacto_2, x:`${dia} - ${hours}:${minutes}`})
        }
    },

    setCliente({commit,state,dispatch,rootState},cliente){
        commit('setCliente',cliente)
        state.client.on('connect', () => {
            console.log('Connection succeeded!')
            this.dispatch('timer/iniciarTemporizador');
      
            this.dispatch('nodered/doSubscribe',process.env.VUE_APP_TOPIC_CICLO_ACTUAL)
            this.dispatch('nodered/doSubscribe',process.env.VUE_APP_TOPIC_VIDA)
            // pedimos los datos del ciclo actual
            this.dispatch('nodered/doPublish',{topic:process.env.VUE_APP_TOPIC_SOLICITAR_TRATAMIENTO})
            
            this.dispatch('nodered/doSubscribe',process.env.VUE_APP_TOPIC_TIEMPO_REAL)
            this.dispatch('nodered/doSubscribe',process.env.VUE_APP_TOPIC_DATOS_PLC)
            this.dispatch('nodered/doSubscribe',process.env.VUE_APP_TOPIC_ALARMAS)
          })
      
          state.client.on("message", (topic, message) => {
           
            const text = new TextDecoder().decode(message);
            const mensaje_tratado = JSON.parse(text);
      
            if(topic==process.env.VUE_APP_TOPIC_VIDA){
                //dispatch local
                dispatch('tratarBitVida',mensaje_tratado)
            }
            if (topic == process.env.VUE_APP_TOPIC_CICLO_ACTUAL) {
                if(!rootState.datosAntiguosCargados){

                    console.log("DATOS DE CICLO EN MENSAJES.JS")
                    dispatch('getDatosTrabajo',mensaje_tratado)
                    this.dispatch('setDatosAntiguosCargados',true)
    
                }
            }
            else if(topic==process.env.VUE_APP_TOPIC_TIEMPO_REAL){
                dispatch('tratar_datos_tratamiento',mensaje_tratado)
            }
            else if(topic == process.env.VUE_APP_TOPIC_DATOS_PLC){
                this.dispatch('setDatosPopup',mensaje_tratado)
            }
            else if(topic == process.env.VUE_APP_TOPIC_ALARMAS){
                this.dispatch('setAlarmasActivas',mensaje_tratado)
            }
          });
          state.client.on('error', error => {
            console.log('Connection failed', error)
          })      
    }

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
